import React, { ReactNode, useMemo } from 'react'
import cs from 'classnames'
import './style.sass'

type GridProps = {
	className?: string
	children: ReactNode
	size?: number
}

export const GridItem = (props: GridProps) => {
	const { children, size = 12, className = '' } = props
	const style = useMemo(() => {
		const width = `${Math.round((size / 12) * 10e7) / 10e5}%`
		return {
			flexBasis: width,
			flexGrow: 0,
			maxWidth: width,
		}
	}, [size])
	const cx = cs('Grid__Item', className)
	return (
		<div className={cx} style={style}>
			{children}
		</div>
	)
}

type GridContainerProps = {
	children: ReactNode
	className?: string
}

export const GridContainer = (props: GridContainerProps) => {
	const { children, className = '' } = props
	const cx = cs('Grid__Container', className)
	return <div className={cx}>{children}</div>
}
